import { AnimatePresence, motion } from 'motion/react';
import { useVersionCheck } from '../hooks/useVersionCheck';
import './UpdateToast.css';

export default function UpdateToast() {
  const { updateAvailable, dismiss, update } = useVersionCheck();

  return (
    <AnimatePresence>
      {updateAvailable && (
        <motion.div
          className="update-toast"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ type: 'spring', damping: 26, stiffness: 300, mass: 0.8 }}
        >
          <span className="update-toast-text">Доступно обновление</span>
          <div className="update-toast-actions">
            <button className="update-toast-dismiss" onClick={dismiss} aria-label="Закрыть">
              
            </button>
            <button className="update-toast-btn" onClick={update}>
              Обновить
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
